import { useMemo, useState } from "react";
import FilmCard from "@/components/feature/FilmCard";
import { films } from "@/mocks/films";

const PAGE_SIZE = 6;

export default function LatestFilms() {
  const sorted = useMemo(() => [...films].sort((a, b) => b.year - a.year).slice(0, 12), []);
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(sorted.length / PAGE_SIZE);
  const pageItems = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const changePage = (next: number) => {
    setPage(next);
    document.getElementById("latest-films")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  if (sorted.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-inbox-archive-line text-3xl"></i>
        </span>
        <p className="mt-4 text-sm text-foreground-600">暂无推荐影视</p>
      </div>
    );
  }

  return (
    <div id="latest-films">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {pageItems.map((film) => (
          <FilmCard key={film.id} film={film} />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-center gap-2 mt-9">
          <button
            onClick={() => changePage(Math.max(1, page - 1))}
            disabled={page === 1}
            className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
            aria-label="上一页"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
            <button
              key={n}
              onClick={() => changePage(n)}
              className={`w-9 h-9 flex items-center justify-center rounded-md text-sm font-medium transition-colors cursor-pointer ${
                n === page
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-200 text-foreground-700 hover:bg-background-100"
              }`}
            >
              {n}
            </button>
          ))}
          <button
            onClick={() => changePage(Math.min(totalPages, page + 1))}
            disabled={page === totalPages}
            className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
            aria-label="下一页"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      )}
    </div>
  );
}